import cx from 'classnames';

import SpinnerLargeIcon from '../assets/svgs/spinner-large.svg';
import SpinnerIcon from '../assets/svgs/spinner.svg';
import { SizeType } from '../types/base';
import styles from './spinner.module.scss';

interface Props {
  size?: 'tiny' | SizeType;
  defaultDescription?: boolean;
  description?: string;
  className?: string;
  center?: boolean;
}

/**
 * @deprecated Use `Spinner` from `@flipster/react/design-system` instead.
 * This component is part of the legacy UI library and will be removed in a future version.
 */
export const Spinner = ({ size = 'small', defaultDescription, description, center, className }: Props) => {
  return (
    <div className={cx(styles.wrapper, styles[size], className, { [styles.center]: center })}>
      {size !== 'large' && <SpinnerIcon />}
      {size === 'large' && <SpinnerLargeIcon />}
      {defaultDescription && <p>Loading...</p>}
      {description && <p>{description}</p>}
    </div>
  );
};

/**
 * @deprecated Use `Spinner` or `SpinnerBox` from `@flipster/react/design-system` instead.
 * This component is part of the legacy UI library and will be removed in a future version.
 */
export const Loading = () => {
  return (
    <div className={styles.loading}>
      <Spinner size='small' center />
    </div>
  );
};
